module.exports = __webpack_public_path__ + "img/post1.67210b3a.jpg";